(function() {
  'use strict';

  function initBundleCards(root) {
    root = root || document;
    var cards = root.querySelectorAll('[data-bundle-card]');
    cards.forEach(function(card) {
      card.addEventListener('click', function(e) {
        if (e.target.tagName === 'A') return;
        card.classList.toggle('is-selected');
      });
      card.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          card.classList.toggle('is-selected');
        }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initBundleCards(document);
  });

  document.addEventListener('shopify:section:load', function(e) {
    initBundleCards(e.target);
  });
})();
